import { useState } from 'react'
import { Button, CloseButton, Drawer, HStack, Input, Portal, VStack } from '@chakra-ui/react'
import { COULDNT_KNOCK_REASONS, type CouldntKnockReason } from '../../../lib/doorDraft'

/** [Spec §4.4] Couldn't knock (household) / Couldn't get in (worksite): a required reason → Inaccessible. */
export function CouldntKnockSheet({ open, title, onRecord, onClose, isSaving }: {
  open: boolean; title: string; onRecord: (reason: CouldntKnockReason, other: string) => void
  onClose: () => void; isSaving: boolean
}) {
  const [reason, setReason] = useState<CouldntKnockReason | null>(null)
  const [other, setOther] = useState('')
  const ready = reason !== null && (reason !== 'Other' || other.trim().length > 0)
  return (
    <Drawer.Root open={open} placement="bottom" onOpenChange={(e) => { if (!e.open) onClose() }}>
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content borderTopRadius="xl" pb="env(safe-area-inset-bottom, 0px)" shadow="popover">
            <Drawer.CloseTrigger asChild><CloseButton size="sm" minW="44px" minH="44px" /></Drawer.CloseTrigger>
            <Drawer.Header><Drawer.Title>{title}</Drawer.Title></Drawer.Header>
            <Drawer.Body>
              <VStack align="stretch" gap={4} pb={4}>
                <HStack gap={2} wrap="wrap">
                  {COULDNT_KNOCK_REASONS.map(r => (
                    <Button key={r.value} minH="44px" borderRadius="full" variant="outline" aria-pressed={reason === r.value}
                      borderColor={reason === r.value ? 'accent' : 'border'} bg={reason === r.value ? 'accent.soft' : 'surface'}
                      color={reason === r.value ? 'accent' : 'fg'} onClick={() => setReason(r.value)}>
                      {r.label}
                    </Button>
                  ))}
                </HStack>
                {reason === 'Other' && (
                  <Input aria-label="What stopped you?" placeholder="What stopped you?" minH="44px" maxLength={200}
                    value={other} onChange={(e) => setOther(e.target.value)} />
                )}
                <Button minH="52px" bg="accent" color="accent.fg" disabled={!ready || isSaving}
                  onClick={() => reason && onRecord(reason, other)}>Record</Button>
              </VStack>
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  )
}
